import React, { FC } from 'react'

import classes from './ErrorIcon.module.scss'

export const ErrorIcon: FC = () => (
  <span className={classes.errorIconWrapper}>!</span>
)

export default ErrorIcon
